import { przelewy24CardAdapter } from './przelewy24'
import { payuCardAdapter } from './payu'
import { CardAdapter } from '../types'

/** klucz = cardForm.provider. Nowy operator z formularzem karty u nas = jeden wpis tutaj. */
export const cardAdapters: Record<string, CardAdapter> = {
  payu: payuCardAdapter,
  przelewy24: przelewy24CardAdapter
}

export const getCardAdapter = (cardForm?: payments.CardForm) =>
  cardForm?.provider ? cardAdapters[cardForm.provider] : undefined

export const hasCardAdapter = (cardForm?: payments.CardForm) =>
  cardForm?.mode === 'embedded' && !!getCardAdapter(cardForm)
